var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCleverIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3",
    "data-name": "Group 3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 84.955 84.744",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M85.465,78.479a7.765,7.765,0,0,1-6.5,6.795H6.8A7.765,7.765,0,0,1,.51,78.479V7.367A7.934,7.934,0,0,1,7.389.53h71.2a7.934,7.934,0,0,1,6.879,6.837c0,2.152,0,4.22,0,6.457V76.242A13.154,13.154,0,0,0,85.465,78.479Z",
    transform: "translate(-0.51 -0.53)",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M3.693,32.322a28.614,28.614,0,0,1,32.2-28.15,30.344,30.344,0,0,1,18.063,7.47c.844.8,1.1,1.266.211,2.237-2.11,2.279-4.22,4.642-6.119,7.048-.633.76-1.013.76-1.773,0a20.089,20.089,0,0,0-10.551-5.275A16,16,0,0,0,17.2,28.313a18.7,18.7,0,0,0,6.119,19.329,17.514,17.514,0,0,0,21.1-.675c1.139-.8,2.068-2.574,3.418-2.279s2.026,1.773,3,2.785l2.954,2.954c1.815,1.815,1.73,1.773,0,3.629C41.633,66.422,16.987,65.283,7.364,47.6A29.542,29.542,0,0,1,3.693,32.322Z",
    transform: "translate(9.686 10.472)",
    fill: "#3f4cef"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleverIcon);
export default __webpack_public_path__ + "static/media/cleverIcon.d80c2adb03967475ef4b27cee1ba6364.svg";
export { ForwardRef as ReactComponent };